import { useState } from 'react';
import { useAuth } from '@/context/AuthContext';
import { PAGE_PATHS, useRouter } from '@/lib/router';
import { authPillLabel } from './authPillLabel';

/** The sign-in / account pill in the nav bar. Its signed-out face comes from the stylesheet. */
export function AuthPill() {
  const { user, isAuthenticated, signOut } = useAuth();
  const { navigate } = useRouter();
  const [hovered, setHovered] = useState(false);
  const label = authPillLabel({ isAuthenticated, firstName: user?.firstName, hovered });

  async function activate() {
    if (!isAuthenticated) {
      navigate(PAGE_PATHS['sign-in']);
      return;
    }
    // First click (or tap) arms, a click while it reads SIGN OUT? signs out.
    if (hovered && label === 'SIGN OUT?') {
      await signOut();
      setHovered(false);
    } else {
      setHovered(true);
    }
  }

  return (
    <button
      className="nav__auth-btn"
      title={isAuthenticated ? 'Click to sign out' : 'Sign In'}
      onClick={() => {
        void activate();
      }}
      onMouseEnter={() => {
        setHovered(true);
      }}
      onMouseLeave={() => {
        setHovered(false);
      }}
      data-magnetic="true"
      data-omega-signin={label === 'SIGN IN' ? '1' : undefined}
      style={{
        fontFamily: isAuthenticated ? 'var(--font-heading-alt)' : 'var(--font-matrix)',
        letterSpacing: hovered ? '0.15em' : '0.1em',
        color: 'var(--color-matrix-neon)',
        borderColor: hovered ? 'var(--color-matrix-neon)' : 'rgba(255, 255, 255, 0.15)',
        textShadow: hovered ? '0 0 10px rgba(0, 255, 65, 0.4)' : 'none',
        transition: 'border-color 0.2s ease, letter-spacing 0.2s ease',
        minWidth: '80px',
      }}
    >
      {label}
    </button>
  );
}
